import {LanguageDto, TypefamilyDto, KumaViewDto, RegionDto, CnrDto, ModelyearDto, ModeltypeBasicDto} from "../../services/Client";
import * as _ from "lodash";

/** adapter for data to handle other presentation of some data */
export default class DataAdapterKumaView {
    constructor(private val: KumaViewDto) {
    }

    get value() {
        return this.val;
    }

    get objectId() {
        return this.value.objectId;
    }

    get title() {
        return this.value.title;
    }

    set title(newValue: string | undefined) {
        this.value.title = newValue;
    }

    get regions() {
        return this.val.regions;
    }

    set regions(newValue: RegionDto[]) {
        this.value.regions = newValue;
    }

    get assignedCnrs() {
        return this.val.assignedCnrs;
    }

    set assignedCnrs(newValue: CnrDto[]) {
        this.value.assignedCnrs = newValue;
    }

    get architectureSystems() {
        return this.val.architectureSystems;
    }

    set architectureSystems(newValue: string|undefined) {
        this.value.architectureSystems = newValue;
    }

    get typefamilies() {
        return this.value.typefamilies;
    }

    set typefamilies(newValue: TypefamilyDto[]) {
        this.value.typefamilies = newValue;
    }

    get modelyears() {
        return this.value.modelyears || [];
    }

    set modelyears(newValue: ModelyearDto[]) {
        this.value.modelyears = newValue;
    }
    set derivates(newValue:ModeltypeBasicDto[]) {
        this.value.derivates = newValue;
    }
    get changedBy() {
        return this.value.metadata ?  this.value.metadata.changedBy : undefined;
    }

    get changedTimestamp() {
        return this.value.metadata ? this.value.metadata.changedTimestamp : undefined;
    }
    set detail(newValue: string | undefined) {
        this.val.detail = newValue;
    }
    get detail() {
        return this.val.detail;
    }
}



// WEBPACK FOOTER //
// ./src/views/KumaView/DataAdapterKumaView.tsx